import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import SingleTestimonialThree from '../../components/Testimonial/SingleTestimonialThree';

import testimonialImg from '../../assets/img/testimonial/thumb-5-1.jpg';
import avatarImg1 from '../../assets/img/testimonial/avatar-5.png';
import avatarImg2 from '../../assets/img/testimonial/avatar-1.png';

const Testimonial = () => {
  const sliderOption = {
    speed: 1500,
    loop: true,
    slidesPerView: '1',
    spaceBetween: 30,
    pagination: {
      el: '.it-slider-dots',
      clickable: true,
    },
  };
  return (
    <div
      id="it-testimonial"
      className="it-testimonial-area it-testimonial-2-ptb it-testimonial-style-3 pb-120 pt-150 p-relative"
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="it-testimonial-2-title-box text-center mb-70">
              <span className="it-section-subtitle red-border">
                Heart Care Based Solutions
              </span>
              <h3 className="it-section-title d-block">
                What Are They Saying About <br /> Our Services
              </h3>
            </div>
          </div>
        </div>
        <div className="it-testimonial-2-wrap p-relative">
          <div className="row">
            <div className="col-xl-5 col-lg-5">
              <div className="it-testimonial-2-thumb-sm z-index">
                <img src={testimonialImg} alt="" />
              </div>
            </div>
            <div className="col-xl-7 col-lg-7">
              <div className="it-testimonial-2-right z-index">
                <div className="it-testimonial-2-wrapper p-relative">
                  <div className="swiper-container it-testimonial-3-active">
                    <Swiper
                      modules={[Pagination]}
                      {...sliderOption}
                      className="swiper-wrapper "
                    >
                      <SwiperSlide className="swiper-slide">
                        <SingleTestimonialThree
                          description={`Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, sed do eiusmod tempor incididunt ut labore
                              et dolore magna aliqua. Ut enim ad minim veniam,
                              quis nostrud exercitation ullamco laboris nisi ut
                              aliquip ex ea commodo consequat. Duis aute irure
                              dolor in reprehenderit in voluptate velit esse
                              cillum dolore  eu fugiat nulla pariatur.
                              Excepteur sint occaecat cupidatat non proident,
                              sunt in culpa qui officia 
                              deserunt mollit`}
                          avatarImage={avatarImg1}
                          authorName="Shophie Laurier"
                          designation="Tripadisor"
                        />
                      </SwiperSlide>
                      <SwiperSlide className="swiper-slide">
                        <SingleTestimonialThree
                          description={`Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, sed do eiusmod tempor incididunt ut labore
                              et dolore magna aliqua. Ut enim ad minim veniam,
                              quis nostrud exercitation ullamco laboris nisi ut
                              aliquip ex ea commodo consequat. Duis aute irure
                              dolor in reprehenderit in voluptate velit esse
                              cillum dolore  eu fugiat nulla pariatur.
                              Excepteur sint occaecat cupidatat non proident,
                              sunt in culpa qui officia 
                              deserunt mollit`}
                          avatarImage={avatarImg2}
                          authorName="Patrice Tardif"
                          designation="Tripadisor"
                        />
                      </SwiperSlide>
                      <SwiperSlide className="swiper-slide">
                        <SingleTestimonialThree
                          description={`Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, sed do eiusmod tempor incididunt ut labore
                              et dolore magna aliqua. Ut enim ad minim veniam,
                              quis nostrud exercitation ullamco laboris nisi ut
                              aliquip ex ea commodo consequat. Duis aute irure
                              dolor in reprehenderit in voluptate velit esse
                              cillum dolore  eu fugiat nulla pariatur.
                              Excepteur sint occaecat cupidatat non proident,
                              sunt in culpa qui officia 
                              deserunt mollit`}
                          avatarImage={avatarImg1}
                          authorName="Shophie Laurier"
                          designation="Tripadisor"
                        />
                      </SwiperSlide>
                      <SwiperSlide className="swiper-slide">
                        <SingleTestimonialThree
                          description={`Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit, sed do eiusmod tempor incididunt ut labore
                              et dolore magna aliqua. Ut enim ad minim veniam,
                              quis nostrud exercitation ullamco laboris nisi ut
                              aliquip ex ea commodo consequat. Duis aute irure
                              dolor in reprehenderit in voluptate velit esse
                              cillum dolore  eu fugiat nulla pariatur.
                              Excepteur sint occaecat cupidatat non proident,
                              sunt in culpa qui officia 
                              deserunt mollit`}
                          avatarImage={avatarImg2}
                          authorName="Patrice Tardif"
                          designation="Tripadisor"
                        />
                      </SwiperSlide>
                    </Swiper>
                  </div>
                  <div className="it-slider-dots text-end"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
